<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  @import "./static/css/style.css";
  #app{
    min-height: 100%;
  }
  
</style>



// WEBPACK FOOTER //
// src/App.vue